import{Locale as m}from"./Locale.enum.mjs";import{getWithDefault as o}from"../utils/MapUtils.mjs";function r(r,t,i=""){return o(r,t,m.ja,i)}export{r as getNameWithDefault};
